export const REGISTER_SOURCES = {
  SQUARE: "square",
  SQUARE_WAITLY: "sqWaitly",
  SQUARE_SUBSCRIPTION: "squareSubscription",
  PJ: "pj",
  RESTAURANT: "restaurant"
};
